import { EventStatusType } from 'schema-dts'

const SportEventStatus: { [key: string]: EventStatusType | undefined } = {
    POSTPONED: 'https://schema.org/EventPostponed',
    CANCELLED: 'https://schema.org/EventCancelled',
    DEFAULT: 'https://schema.org/EventScheduled',
}
export default SportEventStatus
